(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lb-retailer-login/assets/javascripts/change-password.js') >= 0) return;  svs.modules.push('/modules/lb-retailer-login/assets/javascripts/change-password.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const _svs$core = svs.core,
  jupiter = _svs$core.jupiter,
  userSession = _svs$core.userSession;
const Button = svs.ui.Button;
const _svs$components$dialo = svs.components.dialog,
  Confirm = _svs$components$dialo.Confirm,
  branding = _svs$components$dialo.branding,
  message = _svs$components$dialo.message,
  api = _svs$components$dialo.api,
  type = _svs$components$dialo.type;
const url = svs.lb_retailer_login.data.login.url;
const getLogger = svs.core.log.getLogger;
const logger = getLogger('lb-retailer-login');
const showDialog = () => {
  const title = 'Något gick fel';
  const dialog = new Confirm({
    branding: branding.SPORT,
    type: type.ERROR,
    title,
    message: [{
      type: message.TEXT,
      text: 'Var vänlig försök igen senare.'
    }],
    actions: [{
      title: 'Stäng',
      callback: () => {
        dialog.close();
      }
    }]
  });
  api.add(dialog);
};
const ChangePassword = () => {
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    currentPassword = _useState2[0],
    setCurrentPassword = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    newPassword = _useState4[0],
    setNewPassword = _useState4[1];
  const _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    confirmPassword = _useState6[0],
    setConfirmPassword = _useState6[1];
  const _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    formError = _useState8[0],
    setFormError = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    hasTouched = _useState0[0],
    setHasTouched = _useState0[1];
  useEffect(() => {
    function validatePassword() {
      const errors = {};
      if (!/\d/.test(newPassword)) {
        errors.newPassword = 'Nya lösenordet måste innehålla minst 1 siffra.';
      } else if (!/\D/.test(newPassword)) {
        errors.newPassword = 'Nya lösenordet måste innehålla minst 1 bokstav.';
      } else {
        errors.newPassword = '';
      }
      if (newPassword !== confirmPassword) {
        errors.confirmPassword = 'Lösenorden stämmer inte överens.';
      } else {
        errors.confirmPassword = '';
      }
      if (Object.keys(errors).filter(s => Boolean(errors[s])).length > 0) {
        errors.stopLogin = true;
      } else {
        errors.stopLogin = false;
      }
      return errors;
    }
    const clientValidationErrors = validatePassword();
    setFormError(errors => _objectSpread(_objectSpread({}, errors), clientValidationErrors));
  }, [currentPassword, newPassword, confirmPassword]);
  function handleSubmit(e) {
    e.preventDefault();
    function onLoginSuccess() {
      location.href = url;
    }
    function onLoginError(response) {
      const responseCode = response.responseJSON.error.code;
      const errorCode = typeof responseCode === 'number' ? responseCode : Number(responseCode.replace(/\s/, ''));
      logger.info("retailerLogin: Error password change ".concat(errorCode));
      switch (errorCode) {
        case 6243:
          setFormError(_objectSpread(_objectSpread({}, formError), {}, {
            currentPassword: 'Fel lösenord.'
          }));
          break;
        case 6124:
          setFormError(_objectSpread(_objectSpread({}, formError), {}, {
            newPassword: 'Lösenordet får inte vara identiskt med ditt nuvarande lösenord.',
            currentPassword: ''
          }));
          break;
        case 6125:
          setFormError(_objectSpread(_objectSpread({}, formError), {}, {
            newPassword: 'Lösenordet är för kort.',
            currentPassword: ''
          }));
          break;
        default:
          showDialog();
      }
    }
    setHasTouched(true);
    if (formError.stopLogin) {
      return;
    }
    jupiter.put({
      path: '/user/2/password',
      data: {
        oldPassword: currentPassword,
        newPassword
      }
    }, onLoginSuccess, onLoginError);
  }
  return React.createElement("div", {
    className: "bg-white border-grey-300 padding-3",
    style: {
      width: 465,
      borderWidth: 1,
      borderStyle: 'solid',
      marginLeft: 'auto',
      marginRight: 'auto',
      borderRadius: 4
    }
  }, React.createElement("form", {
    autoComplete: "off",
    onSubmit: handleSubmit
  }, React.createElement("h1", {
    className: "f-800 margin-bottom-1",
    style: {
      fontSize: 22
    }
  }, "Du beh\xF6ver byta l\xF6senord"), React.createElement("p", null, "Ditt eng\xE5ngsl\xF6senord beh\xF6ver bytas till ett som du sj\xE4lv v\xE4ljer."), React.createElement("div", {
    className: "control-group".concat(formError.currentPassword && hasTouched ? ' error' : '')
  }, React.createElement("div", {
    className: "has-input-action input-action-has-label js-input-action-show-password"
  }, React.createElement("label", {
    htmlFor: "current_password"
  }, "NUVARANDE L\xD6SENORD"), React.createElement("i", {
    className: "js-input-action input-action"
  }), React.createElement("input", {
    className: "js-input std-input qa-current-password",
    id: "current_password",
    onChange: e => {
      setCurrentPassword(e.target.value);
    },
    required: true,
    type: "password",
    value: currentPassword
  })), React.createElement("div", {
    className: "error-message"
  }, formError.currentPassword)), React.createElement("div", {
    className: "control-group".concat(formError.newPassword && hasTouched ? ' error' : '')
  }, React.createElement("div", {
    className: "has-input-action input-action-has-label js-input-action-show-password"
  }, React.createElement("label", {
    htmlFor: "new_password"
  }, "NYTT L\xD6SENORD"), React.createElement("i", {
    className: "js-input-action input-action"
  }), React.createElement("input", {
    className: "js-input std-input qa-new-password",
    id: "new_password",
    minLength: 2,
    onChange: e => {
      setNewPassword(e.target.value);
    },
    required: true,
    type: "password",
    value: newPassword
  })), React.createElement("div", {
    className: "error-message"
  }, formError.newPassword)), React.createElement("div", {
    className: "control-group margin-bottom-2".concat(formError.confirmPassword && hasTouched ? ' error' : '')
  }, React.createElement("div", {
    className: "has-input-action input-action-has-label js-input-action-show-password"
  }, React.createElement("label", {
    htmlFor: "confirm_password"
  }, "UPPREPA NYTT L\xD6SENORD"), React.createElement("i", {
    className: "js-input-action input-action"
  }), React.createElement("input", {
    className: "js-input std-input qa-confirm-password",
    id: "confirm_password",
    minLength: 2,
    onChange: e => {
      setConfirmPassword(e.target.value);
    },
    required: true,
    type: "password",
    value: confirmPassword
  })), React.createElement("div", {
    className: "error-message"
  }, formError.confirmPassword)), React.createElement("div", {
    className: "grid-row"
  }, React.createElement("div", {
    className: "col-xs-6 padding-xs-right-1"
  }, React.createElement(Button, {
    block: true,
    className: "qa-cancel",
    onClick: () => userSession.logout(),
    transparent: true
  }, "Avbryt")), React.createElement("div", {
    className: "col-xs-6 padding-xs-left-1"
  }, React.createElement(Button, {
    block: true,
    className: "qa-login",
    focus: true,
    type: "submit"
  }, "BYT L\xD6SENORD")))));
};
setGlobal('svs.lb_retailer_login.ChangePassword', ChangePassword);

 })(window);